export default "__VITE_ASSET__CMOI2cfq__"